/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown> }} Err_Tournament_Player_Wrong_StateInputs */



/**
* | output |
* | --- |
* | "Player must be Registered (currently {current})" |
*
* @param {Err_Tournament_Player_Wrong_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_wrong_state = /** @type {((inputs: Err_Tournament_Player_Wrong_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_Wrong_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le joueur doit être Inscrit (actuellement ${i?.current})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El jugador debe estar Inscrito (actualmente ${i?.current})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`O jogador deve estar Inscrito (atualmente ${i?.current})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il giocatore deve essere Iscritto (attualmente ${i?.current})`)
	return /** @type {LocalizedString} */ (`Player must be Registered (currently ${i?.current})`)
});